import * as types from './types';

const archivePosting = (postings, isDraft = false, particularNotFree, isOffline, finishReasonId, finishReasonText) => ({
  type: types.ARCHIVE_POSTING,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v2/posting/archive',
    method: 'PUT',
    body: { postings, finishReasonId, finishReasonText },
    particularNotFree,
    isDraft,
    isOffline
  }
});

const resetArchivePosting = () => ({
  type: types.RESET_ARCHIVE_POSTING
});

export { archivePosting, resetArchivePosting };
